import React from 'react';
import { useMessageGetter } from '@messageformat/react';
import { Form, FormRow, TextInput } from '@op/opds.opux';

const CompanySearch = ({ setSearchTerm }) => {
    const searchInputId = 'company-search-input';
    const msg = useMessageGetter('fp');
    return (
        <Form stacked>
            <FormRow label={msg('representation.search.title')} labelFor={searchInputId}>
                <TextInput
                    id={searchInputId}
                    placeholder={msg('representation.search.placeholder')}
                    autoComplete='off'
                    maxLength={50}
                    aria-label={msg('representation.search.title') + '. ' + msg('representation.search.ariaLabel')}
                    onChange={(event) => {
                        setSearchTerm(event.target.value);
                    }}
                />
            </FormRow>
        </Form>
    );
};

export default CompanySearch;
